var antPrefixCls = '.ant-drawer';
var drawerStyleFn = function drawerStyleFn(token) {
  var _antPrefixCls, _ref;
  return _ref = {}, _ref[antPrefixCls] = (_antPrefixCls = {}, _antPrefixCls[antPrefixCls + "-header"] = {
    padding: '16px 16px 16px 24px'
  }, _antPrefixCls[antPrefixCls + "-close"] = {
    marginInlineEnd: 0,
    order: 1
  }, _antPrefixCls[antPrefixCls + "-extra"] = {
    marginInlineEnd: token.marginSM
  }, _antPrefixCls[antPrefixCls + "-body"] = {
    padding: '24px'
  }, _antPrefixCls[antPrefixCls + "-footer"] = {
    padding: token.padding + "px " + token.paddingLG + "px"
  }, _antPrefixCls), _ref;
};

export { drawerStyleFn };
